import React, { useEffect, useState } from "react";
import "./UserDetailModal.css";

export default function UserDetailModal({ isOpen, onClose, user, agentId, agentCif, agentName }) {
    // State riêng để lưu số điện thoại sau khi lookup
    const [fetchedPhone, setFetchedPhone] = useState("");

    // Reset phone khi mở user mới
    useEffect(() => {
        if (isOpen) {
            setFetchedPhone(""); 
        }
    }, [isOpen, user]);

    // LOGIC LOOKUP PHONE (Giống hệt EditUserModal)
    useEffect(() => {
        const fetchMissingPhone = async () => {
            // Nếu user đã có phone từ API list thì dùng luôn, chưa có mới đi tìm
            if (isOpen && user && user.cif_number && !user.phone && !fetchedPhone) {
                try {
                    const token = localStorage.getItem("access_token");
                    const targetAgentId = agentId || user.agent_id;
                    
                    const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/lookup/customer?agent_id=${targetAgentId}&customer_cif=${user.cif_number}`, {
                        method: "GET",
                        headers: { "Authorization": `Bearer ${token}` }
                    });

                    if (response.ok) {
                        const data = await response.json();
                        if (data.phone) {
                            setFetchedPhone(data.phone);
                        }
                    }
                } catch (error) {
                    console.error("Lỗi lookup phone:", error);
                }
            }
        };

        fetchMissingPhone();
    }, [isOpen, user, agentId, fetchedPhone]);

    if (!isOpen || !user) return null;

    const stop = (e) => e.stopPropagation();

    // Helper format tiền
    const formatCurrency = (val) => {
        if (!val && val !== 0) return "0 VND";
        return Number(val).toLocaleString('vi-VN') + " VND";
    };

    // Helper map trạng thái
    const getStatusDisplay = (status) => {
        const map = {
            "ACTIVE": "Hoạt động",
            "LOCKED": "Tạm khóa",
            "CLOSED": "Đóng",
            "WAITING_ACTIVATION": "Chờ kích hoạt",
            "PENDING": "Chờ kích hoạt"
        };
        return map[status] || status;
    };

    return (
        <div className="user-detail-overlay" onClick={onClose}>
            <div className="user-detail-modal" onClick={stop}>
                {/* Header */}
                <div className="user-detail-header">
                    <h2>Xem thông tin người dùng</h2>
                    <button className="user-detail-close" onClick={onClose}>✕</button>
                </div>

                {/* Body */}
                <div className="user-detail-body">
                    <form className="user-detail-form">
                        
                        {/* HÀNG 1 */}
                        <div className="user-detail-field">
                            <label>CIF Đại lý thanh toán <span className="required">*</span></label>
                            <input type="text" value={agentCif || ""} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Tên Đại lý thanh toán <span className="required">*</span></label>
                            <input type="text" value={agentName || ""} readOnly />
                        </div>

                        {/* HÀNG 2: MÃ KH & TÊN KH */}
                        <div className="user-detail-field">
                            <label>Mã khách hàng <span className="required">*</span></label>
                            <input type="text" value={user.cif_number || user.cif || ""} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Tên khách hàng</label>
                            <input type="text" value={user.full_name || user.customerName || ""} readOnly />
                        </div>

                        {/* HÀNG 3: ĐIỆN THOẠI & EMAIL */}
                        <div className="user-detail-field">
                            <label>Điện thoại <span className="required">*</span></label>
                            {/* Ưu tiên số vừa lookup được -> số có sẵn trong user -> rỗng */}
                            <input type="text" value={fetchedPhone || user.phone || ""} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Email</label>
                            <input type="text" value={user.email || ""} readOnly />
                        </div>

                        {/* HÀNG 4: USERNAME & CHANNEL */}
                        <div className="user-detail-field">
                            <label>Username <span className="required">*</span></label>
                            <input type="text" value={user.username || ""} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Kênh nhận user/Password</label>
                            <input type="text" value="Notice (Digimi) và Email" readOnly />
                        </div>

                        {/* HÀNG 5: ROLE & STATUS */}
                        <div className="user-detail-field">
                            <label>Nhóm quyền app Agent <span className="required">*</span></label>
                            <input type="text" value={user.role || ""} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Trạng thái</label>
                            {/* Dùng helper để hiển thị tiếng Việt */}
                            <input type="text" value={getStatusDisplay(user.status)} readOnly />
                        </div>

                        {/* HÀNG 6: HẠN MỨC (TÁCH 2 TRƯỜNG) */}
                        <div className="user-detail-field">
                            <label>Hạn mức nộp trong ngày <span className="required">*</span></label>
                            <input type="text" value={formatCurrency(user.daily_deposit_limit)} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Hạn mức rút trong ngày <span className="required">*</span></label>
                            <input type="text" value={formatCurrency(user.daily_withdraw_limit)} readOnly />
                        </div>

                        {/* HÀNG 7: AUDIT INFO */}
                        <div className="user-detail-field">
                            <label>User tạo</label>
                            <input type="text" value={user.created_by || ""} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Tên CBNV</label>
                            {/* Nếu API chưa trả về tên CBNV tạo, hiển thị tạm placeholder hoặc logic khác */}
                            <input type="text" value={user.staff_name || "Admin User"} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Branch tạo</label>
                            <input type="text" value={user.branch_created || user.branch_code || ""} readOnly />
                        </div>

                        <div className="user-detail-field">
                            <label>Tên ĐVKD</label>
                            <input type="text" value={user.unit_name || "Hội Sở"} readOnly />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}